import MasterDataMutationTypes from './MasterDataMutationTypes';
import MasterDataService from '../service/MasterDataService';
import MasterDataFileService from '../file/service/MasterDataFileService';
import MasterDataFactory from '../service/MasterDataFactory';
import EventService from '../../../common/event/EventService';
import VirusEvent from '../../../vcom/events/VirusEvent';

async function loadMasterData({ commit }) {
  commit(MasterDataMutationTypes.UPDATE_LOADING_STATE, true);
  try {
    const response = await MasterDataService.get();
    const masterData = MasterDataFactory.makeMasterData(response.data);
    commit(MasterDataMutationTypes.UPDATE_MASTER_DATA, masterData);
  } finally {
    commit(MasterDataMutationTypes.UPDATE_LOADING_STATE, false);
  }
}

async function loadFiles({ commit }) {
  commit(MasterDataMutationTypes.UPDATE_LOADING_STATE, true);
  try {
    const response = await MasterDataFileService.getFiles();
    commit(MasterDataMutationTypes.UPDATE_FILES, response.data);
  } finally {
    commit(MasterDataMutationTypes.UPDATE_LOADING_STATE, false);
  }
}

function updateMasterData({ commit }, masterData) {
  commit(MasterDataMutationTypes.UPDATE_MASTER_DATA, masterData);
}

async function saveMasterData({ commit }, masterData) {
  const response = await MasterDataService.save(masterData);
  commit(MasterDataMutationTypes.UPDATE_MASTER_DATA, response.data);
}

async function saveMasterDataFiles({ commit }, masterDataFiles) {
  try {
    const response = await MasterDataFileService.saveFiles(masterDataFiles);
    const savedFiles = response.data;
    commit(MasterDataMutationTypes.UPDATE_FILES, savedFiles);
  } catch (error) {
    if (error.response?.data?.isFileMalicious !== undefined) {
      EventService.dispatch(VirusEvent.OPEN_VIRUS_FOUND_MODAL, { target: document });
    }
  }
}

async function removeMasterDataFile({ state, commit }, fileToRemove) {
  await MasterDataFileService.removeFile(fileToRemove.id);
  const files = state.files.filter((file) => file.id !== fileToRemove.id);
  commit(MasterDataMutationTypes.UPDATE_FILES, files);
}

const MasterDataActions = {
  saveMasterData,
  saveMasterDataFiles,
  loadMasterData,
  loadFiles,
  updateMasterData,
  removeMasterDataFile,
};

export default MasterDataActions;
